<template>
    <el-dialog :title="title" v-if="visible" :visible.sync="visible" width="80%" :close-on-click-modal="false" top="5vh"
    class="frame-dialog task-appoint-dialog" @close="close">
        <div class="task-appoint" v-loading="getListLoading">
            <div class="appoint-left">
                <div class="appoint-edit-info">
                    <appointment-branch-edit-cont ref="appointmentBranchEditCont" :tableData="tableData"
                        @checkResult="checkResult"></appointment-branch-edit-cont>
                </div>
            </div>
            <div class="appoint-right">
                <dialog-table ref="batchAppointTable" :tableData="tableData" :dialogTable="appointTableColumns" @selectionChange="selectionChange">
                </dialog-table>
                <div class="summarizing">
                    <span>共 {{ tableData.length }} 项</span>
                </div>
            </div>
        </div>
        <PercentLoading ref="percentLoading" :config="{ modal: true }"></PercentLoading>

        <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="handleSave">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import dialogTable from '../../../../../components/dialog/dialogTable';
import { batchAppointmentApi, getReverseTransportAppointmentListApi } from '../../../../../api/appointmentCenter';
import AppointmentBranchEditCont from './AppointmentBranchEditCont';
import config from './appointConfig';
import PercentLoading from './PercentLoading';
import { dictWithUrl } from '@/components/lots/api.js';
import dayjs from 'dayjs';

export default {
    components: { dialogTable, AppointmentBranchEditCont, PercentLoading },
    props: {
        title: String
    },
    data() {
        return {
            visible: false,
            rowsData: [],
            tableData: [],
            getListLoading: false,
            loadingVisible: false,
            appointTableColumns: config.appointmentBranchTable,
            appointInfo: {},
            selectedData: []
        };
    },
    methods: {
        selectionChange(data) {
            this.selectedData = data;
        },
        close() {
            this.visible = false;
            this.tableData = [];
            this.rowsData = [];
            this.selectedData = [];
            this.appointInfo = {};
            this.$refs.appointmentBranchEditCont.reset();
        },
        handleSave() {
            this.$refs.appointmentBranchEditCont.checkSave(this.tableData);
        },
        show(data) {
            const failList = [];
            const list = data.filter(item => {
                // 订单类型=上门取件退货单、退货入库单 & 配送方式=网点配送、宅配 & 任务状态=“待网点备货，待预约网点”、“待调度”、待排车”
                if (!(item.orderTypeExt === 'CSP_REVERSE' && [-20, -10, 0, 5].includes(item.taskStatus))) {
                    failList.push(item.taskNo);
                } else {
                    return item.taskNo;
                }
            });
            const dataLen = data.length;
            const failListLen = failList.length;
            if (!dataLen) {
                return this.$message.warning('请勾选符合预约条件的数据');
            } else if (failListLen) {
                this.$message({
                    message: `订单号${failList.join('、')}，\n共${failListLen}单，不符合预约条件，无需预约，已自动剔除`,
                    type: 'warning',
                    customClass: 'max-zindex'
                });
                if (failListLen === dataLen) {
                    return;
                };
            }
            this.visible = true;
            this.rowsData = list;
            this.getTableList(list);
        },
        async getTableList (data) { // table数据
            const dict = await dictWithUrl('TRANSPORT_STATUS,ORDER_TYPE');
            const dictData = dict.data;
            const params = {
                taskNoList: data.map(i => i.taskNo),
                operateType: 'REVERSE' // 正向订单:FORWARD 逆向订单:REVERSE
            };
            this.getListLoading = true;
            getReverseTransportAppointmentListApi(params).then(res => {
                if (res && +res.code === 0) {
                    if (res.errMsg) {
                        this.$message.error(res.errMsg);
                    }
                    res.data.forEach(item => {
                        item.taskStatusName = dictData.TRANSPORT_STATUS[item.taskStatus];
                        item.orderTypeName = dictData.ORDER_TYPE[item.orderType];
                        item.receiverMsg = [item.finalName, item.finalMobile || item.finalTel, item.receiverDetailAddr].filter(i => i).join('/');
                        if (item.preAppointmentTimeSlot) {
                            item.appointmentTimes = item.preAppointmentTime ? `${dayjs(item.preAppointmentTime).format('YYYY-MM-DD')} ${item.preAppointmentTimeSlot}`
                                : dayjs(item.preAppointmentTime).format('YYYY-MM-DD');
                        } else {
                            item.appointmentTimes = item.preAppointmentTime ? `${dayjs(item.preAppointmentTime).format('YYYY-MM-DD')}` : '';
                        }
                    });
                    this.tableData = res.data;
                    this.$nextTick(() => {
                        this.tableData.forEach(item => {
                            this.$refs.batchAppointTable.$refs.dialogTable.toggleRowSelection(item, true);
                        });
                    });
                }
            }).finally(() => {
                this.getListLoading = false;
            });
        },
        showLoading() {
            this.loadingVisible = true;
            this.$refs.percentLoading.start(100, true);
        },
        closeLoading() {
            this.$refs.percentLoading.start();
        },
        checkResult(data) {
            if (!data) return;
            const taskNoList = this.selectedData.map(row => row.taskNo);
            if (!taskNoList.length) {
                return this.$message.warning('请先勾选订单');
            }
            data.taskNoList = taskNoList;
            this.showLoading();
            batchAppointmentApi(data).then(res => {
                if (res && +res.code === 0) {
                    if (res.errMsg) {
                        this.$message.error(res.errMsg);
                    } else {
                        this.$message.success('预约成功');
                    }
                    this.visible = false;
                    this.$emit('success');
                }
            }).finally(() => {
                this.closeLoading();
                this.getListLoading = false;
            });
        }
    }
};
</script>
<style lang="less">
.max-zindex {
    z-index: 9999!important;
}
.task-appoint-dialog {
    .el-dialog__body {
        padding-top: 0;
        position: relative;
    }
}
.task-appoint {
    display: flex;
    .appoint-left {
        width: 30%;
        padding: 10px 10px 0 0;
        border-right: 1px solid #e6e6e6;
        .el-form-item__label {
            color: #999;
        }
        .el-form-item__content {
            color: #333;
        }
        .el-form-item__content, .el-form-item__label {
            line-height: 24px;
        }
        .base-info {
            border-bottom: 1px solid #e6e6e6;
            margin-bottom: 10px;
            padding-bottom: 5px;
            .el-form-item {
                margin-bottom: 0px;
            }
        }
        .refresh.el-button {
            padding: 0;
            .el-icon-refresh {
                font-size: 14px;
                font-weight: bold;
                color: #00bcbf;
            }
        }
    }
    .appoint-right {
        width: 68%;
        padding: 10px 0 0 10px;
    }
    .summarizing {
        margin-top: 5px;
        :first-child {
            margin-right: 25px;
        }
        i {
            color: #000;
            font-style: normal;
        }
    }
}
</style>
